<template>
  <TemplateView>
    <div class="container" :key="filterStatusParams">
      <TemplatePageGrid
        :items="workClientProjectGrid_filter"
        :page-data="pageData"
        :loading="loadingAnimation"
      >
        <template v-slot:buttons>
          <div class="d-grid gap-5">
            <BaseButton
              v-if="
                pageSales &&
                $userCheckAccess({
                  abilities: 'edit_sales',
                })
              "
              :text="localStorage.translations.pages.sales.buttons['sozdat-proekt']"
              @click="$router.push({ name: 'SalesProjectCreate' })"
              default_icon="button-add"
            />
            <div class="d-flex flex-wrap gap-5">
              <v-hover v-slot="{ hover }">
                <v-btn
                  class="rounded-xl mt-5"
                  :class="filter.name.value ? 'white--text' : 'primary--text'"
                  small
                  min-width="20"
                  :color="filter.name.value ? 'primary' : 'white'"
                  :depressed="!hover"
                  @click="onSort()"
                >
                  <IconSortAlphabetical :sort="filter.name.value"/>
                </v-btn>
              </v-hover>
              <BaseInput
                v-if="filter.status.list.length > 1"
                :label="
                  localStorage.translations.pages['sales_project']['planned_resources-labels'][
                    'status-proekta'
                  ]
                "
                type="autocomplete"
                v-model="filter.status.value"
                :items="filter.status.list"
                placeholder="—"
                multiple
                minimize
                small-chips
                clearable
                @change="onDownloadPageData"
              />
              <BaseInput
                :label="
                  localStorage.translations.pages['sales_project']['project_client-labels'][
                    'klient'
                  ]
                "
                type="autocomplete"
                v-model="filter.client.value"
                :items="filter.client.list"
                placeholder="—"
                multiple
                minimize
                small-chips
                clearable
                @change="onDownloadPageData"
                max-width="500px"
                v-if="userType !== 'subscriber'"
              />
              <div>
                <label class="primary--text f14 fw500 temp">{{
                    localStorage.translations.pages['statistic_project'].tables.period
                  }}</label>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      hide-details
                      v-model="dateRangeText"
                      filled
                      height="30"
                      v-bind="attrs"
                      readonly
                      clearable
                      prepend-inner-icon="today"
                      placeholder="—"
                      v-on="on"
                      class="temp"
                      @click:clear=";(filter.period = []), onDownloadPageData()"
                    />
                  </template>
                  <v-date-picker
                    :locale="$cookies.get('languageSelect').key"
                    v-model="filter.period"
                    range
                    no-title
                    show-week
                    first-day-of-week="1"
                    class="temp"
                  >
                    <BaseButton
                      class="ml-auto mr-0"
                      :text="localStorage.translations.pages.common.buttons.confirm"
                      :disabled="filter.period.length < 1"
                      @click=";(menu = false), onDownloadPageData()"
                    />
                  </v-date-picker>
                </v-menu>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:filters></template>
        <div
          class="projectGrid"
          :class="{ table: $route.query.grid === 'table' }"
          v-if="workClientProjectGrid_filter.length && !loadingAnimation"
        >
          <ProjectCard
            v-for="(project, index) in workClientProjectGrid_filter"
            :project="project"
            :key="index"
          />
        </div>
      </TemplatePageGrid>
    </div>
  </TemplateView>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

import TemplateView from 'components/templates/TemplateView'
import TemplatePageGrid from 'components/templates/TemplatePageGrid'
import ProjectCard from 'components/project/ProjectCard'
import IconSortAlphabetical from 'components/icons/IconSortAlphabetical.vue'
import BaseInput from 'components/base/BaseInput.vue'

export default {
  name: 'salesAll',
  data: () => ({
    menu: false,
    filter: {
      name: {
        list: ['asc', 'desc', ''],
        value: '',
      },
      status: {
        list: [],
        value: [],
      },
      client: {
        list: [],
        value: [],
      },
      period: [],
    },
  }),
  components: {
    BaseInput,
    IconSortAlphabetical,
    ProjectCard,
    TemplateView,
    TemplatePageGrid,
  },
  computed: {
    ...mapGetters('workClientProject', [
      'workClientProjectGrid',
      'workClientProjectGrid_filter',
      'pageData',
    ]),
    ...mapGetters('user', ['userType']),
    ...mapGetters(['loadingAnimation']),
    pageSales() {
      return this.$route.name === 'Sales'
    },
    pageProjects() {
      return this.$route.name === 'Projects'
    },
    pageProjectsDone() {
      return this.$route.name === 'ProjectsDone'
    },
    pageSalesArchive() {
      return this.$route.name === 'SalesArchive'
    },
    filterStatusParams() {
      return this.pageSales
        ? 'creating,bidding'
        : (this.pageProjects
          ? 'pending,in_progress'
          : (this.pageProjectsDone
            ? 'done'
            : (this.pageSalesArchive
              ? 'canceled,intro'
              : '')))
    },
    statusList() {
      return {
        creating:
          this.localStorage.translations.pages.projects_status.status['predvaritelnyy'] || '',
        intro:
          this.localStorage.translations.pages.projects_status.status['tsenopredlozhenie'] || '',
        bidding:
          this.localStorage.translations.pages.projects_status.status['tsenopredlozhenie'] || '',
        canceled:
          this.localStorage.translations.pages.projects_status.status['ne-sostoyavshiysya'] || '',
        pending: this.localStorage.translations.pages.projects_status.status['v-ozhidanii'] || '',
        in_progress: this.localStorage.translations.pages.projects_status.status['v-rabote'] || '',
        done: this.localStorage.translations.pages.projects_status.status['zavershen'] || '',
      }
    },
    dateRangeText() {
      let dates = [...this.filter.period]
      if (dates[0]) {
        dates[0] = this.$formatDate(dates[0])
      }
      if (dates[1]) {
        dates[1] = this.$formatDate(dates[1])
      }
      return dates.join(' - ')
    },
  },
  created() {
    this.onGetFilters()
    //this.onDownloadPageData()
  },
  watch: {
    '$route.query'() {
      this.onDownloadPageData()
    },
    filterStatusParams() {
      this.onGetFilters()

    },
  },
  methods: {
    ...mapActions('workClientProject', [
      'onWorkClientProjectGrid',
      'onWorkClientProjectGrid_filter',
    ]),
    ...mapActions('workClient', ['onWorkClientAll']),
    ...mapMutations(['setLoadingAnimation']),
    async onDownloadPageData() {
      this.setLoadingAnimation(true)
      let data = {
        filter: {
          status: this.filter.status.value.length
            ? this.filter.status.value.join(',')
            : this.filter.status.list.map((d) => d.id).join(','),
        },
        order: {
          name: this.filter.name.value,
        },
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      if (this.filter.client.value.length)
        data.filter.work_client_id = this.filter.client.value.join(',')
      if (this.filter.period.length) data.filter.period = this.filter.period.join(',')
      if (this.$route.query.search) data.search = this.$route.query.search
      await this.onWorkClientProjectGrid_filter(data).then(res => {
        this.setLoadingAnimation(false)
      })
    },
    async onGetFilters() {
      let list = this.filterStatusParams.split(',')
      for (let i in list)
        list[i] = {
          id: list[i],
          name: this.statusList[list[i]],
        }
      this.filter.status.list = list
      await this.onWorkClientAll().then((res) => {
        this.filter.client.list = res.data.data
        this.onDownloadPageData()
      })
    },
    onSort() {
      this.filter.name.value =
        this.filter.name.value === 'asc' ? 'desc' : this.filter.name.value === 'desc' ? '' : 'asc'
      this.onDownloadPageData()
    },
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  display: grid;
  grid-row-gap: 40px;

  .projectGrid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    grid-gap: 24px;

    &.table {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  .btnGrid {
    &.right {
      display: grid;
      align-items: center;
      grid-template-columns: repeat(1, max-content);
      grid-column-gap: 60px;
    }
  }
}

label.temp {
  display: block;
  margin-bottom: 5px;
  line-height: 16px !important;
}

:deep() .v-input.v-text-field .v-input__slot:not(.v-textarea) {
  min-height: 30px !important;
  border-radius: 10px !important;
}
.temp {
  :deep() .v-input__slot{
  width: max-content !important;
  }
}
</style>
